/**
 *
 * This is a function to propose player N games to play.
 * When games is passed it is added into removedInChronologicalOrder
 * Using this information we can determine which of 3 games was passed so we
 *   update slot with new game (if any)
 *
 * Example:
 * I have games A, B, C, D, E, F, G
 *   Nothing is passed yet, so user sees A, B, C as proposed game
 * User passed game B, so we add B to removedInChronologicalOrder
 *   Now proposed games are A, D, C
 * User passed game A, so we add A to removedInChronologicalOrder
 *   Now proposed games are E, D, C
 *
 * Order of removedInChronologicalOrder matters because it is used to determine
 *  which game slot was passed.
 *
 */
export function getMagicSlots(itemsInInitialOrder, removedInChronologicalOrder, slotsCount) {
    // Quite stupid implementation
    if (slotsCount === void 0) { slotsCount = 3; }
    // We can not iterate more than itemsInInitialOrder.length times
    // Because each iteraction we should replace one item in slots
    var healthCheckMaxIterations = itemsInInitialOrder.length + slotsCount + 10;
    var slots = itemsInInitialOrder.slice(0, slotsCount);
    var nextItemIndex = slots.length;
    while (true) {
        var slotCandidateIndex = -1;
        var removedCandidateIndex = -1;
        for (var i = 0; i < slots.length; i++) {
            if (!slots[i]) {
                // This slot is already empty
                continue;
            }
            var removedIndex = removedInChronologicalOrder.indexOf(slots[i]);
            if (removedIndex < 0) {
                // This slot is not passed, try next slot
                continue;
            }
            if (removedCandidateIndex === -1 || removedIndex < removedCandidateIndex) {
                // This slot was passed before, so it will be our new candidate
                slotCandidateIndex = i;
                removedCandidateIndex = removedIndex;
            }
        }
        if (slotCandidateIndex < 0 || removedCandidateIndex < 0) {
            // No more items to propose because all slots are not passed yet
            break;
        }
        else {
            slots[slotCandidateIndex] = itemsInInitialOrder[nextItemIndex];
            nextItemIndex++;
        }
        healthCheckMaxIterations--;
        if (healthCheckMaxIterations === 0) {
            console.error("Infinite loop detected");
            return new Array(slotsCount).fill(undefined);
        }
    }
    return slots;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlc3RMaXN0Lm1hZ2ljU2xvdHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJxdWVzdExpc3QubWFnaWNTbG90cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7O0dBa0JHO0FBQ0gsTUFBTSxVQUFVLGFBQWEsQ0FDM0IsbUJBQXdCLEVBQ3hCLDJCQUFnQyxFQUNoQyxVQUFjO0lBRWQsOEJBQThCO0lBRjlCLDJCQUFBLEVBQUEsY0FBYztJQUlkLGdFQUFnRTtJQUNoRSw4REFBOEQ7SUFDOUQsSUFBSSx3QkFBd0IsR0FBRyxtQkFBbUIsQ0FBQyxNQUFNLEdBQUcsVUFBVSxHQUFHLEVBQUUsQ0FBQztJQUU1RSxJQUFNLEtBQUssR0FBRyxtQkFBbUIsQ0FBQyxLQUFLLENBQUMsQ0FBQyxFQUFFLFVBQVUsQ0FBQyxDQUFDO0lBQ3ZELElBQUksYUFBYSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUM7SUFDakMsT0FBTyxJQUFJLEVBQUU7UUFDWCxJQUFJLGtCQUFrQixHQUFHLENBQUMsQ0FBQyxDQUFDO1FBQzVCLElBQUkscUJBQXFCLEdBQUcsQ0FBQyxDQUFDLENBQUM7UUFDL0IsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7WUFDckMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRTtnQkFDYiw2QkFBNkI7Z0JBQzdCLFNBQVM7YUFDVjtZQUNELElBQU0sWUFBWSxHQUFHLDJCQUEyQixDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztZQUNuRSxJQUFJLFlBQVksR0FBRyxDQUFDLEVBQUU7Z0JBQ3BCLHlDQUF5QztnQkFDekMsU0FBUzthQUNWO1lBRUQsSUFBSSxxQkFBcUIsS0FBSyxDQUFDLENBQUMsSUFBSSxZQUFZLEdBQUcscUJBQXFCLEVBQUU7Z0JBQ3hFLCtEQUErRDtnQkFFL0Qsa0JBQWtCLEdBQUcsQ0FBQyxDQUFDO2dCQUN2QixxQkFBcUIsR0FBRyxZQUFZLENBQUM7YUFDdEM7U0FDRjtRQUVELElBQUksa0JBQWtCLEdBQUcsQ0FBQyxJQUFJLHFCQUFxQixHQUFHLENBQUMsRUFBRTtZQUN2RCxnRUFBZ0U7WUFDaEUsTUFBTTtTQUNQO2FBQU07WUFDTCxLQUFLLENBQUMsa0JBQWtCLENBQUMsR0FBRyxtQkFBbUIsQ0FBQyxhQUFhLENBQUMsQ0FBQztZQUMvRCxhQUFhLEVBQUUsQ0FBQztTQUNqQjtRQUVELHdCQUF3QixFQUFFLENBQUM7UUFDM0IsSUFBSSx3QkFBd0IsS0FBSyxDQUFDLEVBQUU7WUFDbEMsT0FBTyxDQUFDLEtBQUssQ0FBQyx3QkFBd0IsQ0FBQyxDQUFDO1lBQ3hDLE9BQU8sSUFBSSxLQUFLLENBQUMsVUFBVSxDQUFDLENBQUMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1NBQzlDO0tBQ0Y7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMifQ==